import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import EventsCoupon from 'modules/events-coupon/index.js';
const { IntentActionTrigger } = MojitoPresentation.Base.Intent;
const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

export default class SportCouponView extends UIViewImplementation {
    constructor(props) {
        super(props);

        this.onEventListItemClicked = this.onEventListItemClicked.bind(this);
        this.getHrefItem = this.getHrefItem.bind(this);
    }

    onEventListItemClicked(eventId) {
        IntentActionTrigger.showSportEvent(this.props.sportId, eventId);
    }

    getHrefItem(eventId) {
        return NavigationPathBuilder.sportEventPath(
            this.props.sportId,
            eventId,
            this.appContext().routeResolver
        );
    }

    renderTodayTomorrowCoupon(eventGroupId) {
        if (!eventGroupId) {
            return null;
        }

        return (
            <EventsCoupon
                sportId={this.props.sportId}
                eventGroupsId={eventGroupId}
                headerText={this.resolveString('$SPORT_COUPON_VIEW.HEADER')}
                config={this.config.eventCoupon}
                analyticsName={this.props.couponId}
            />
        );
    }

    render() {
        const { todayEventGroupId, tomorrowEventGroupId, couponId } = this.props;
        const { TODAY, TOMORROW } = SportCouponView.COUPONS;
        const isToday = couponId === TODAY;
        const isTomorrow = couponId === TOMORROW;

        if (!isToday && !isTomorrow) {
            return null;
        }

        const eventGroupId = isToday ? todayEventGroupId : tomorrowEventGroupId;
        return this.renderTodayTomorrowCoupon(eventGroupId);
    }
}

SportCouponView.COUPONS = {
    TODAY: 'today',
    TOMORROW: 'tomorrow',
};
